import axios from 'axios';
import AsyncStorage from '@react-native-community/async-storage';
import _ from 'lodash';

import { ISA_TOKEN } from '../constants';

export const interceptorToken = async config => {
  const token = await AsyncStorage.getItem(ISA_TOKEN);

  return {
    ...config,
    headers: token
      ? {
          ..._.merge(config.headers, {
            Authorization: `Bearer ${token}`
          })
        }
      : { ...config.headers }
  };
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
  // baseURL: 'https://isa-api.com'
});

api.interceptors.request.use(interceptorToken);

// api.interceptors.response.use(
//   config => {
//     return config;
//   },
//   error => {
//     // if (error.response && error.response.status === 401) {
//     //   window.location.href = '/login';
//     // }
//     return Promise.reject(error);
//   }
// );

export default api;
